import { apolloClient } from "../apollo/apollo-client";
import { clearCurrentUserCache } from "./currentUserCache";

function logOutAndRedirect() {
    clearCurrentUserCache(apolloClient);
    document.forms["logout-form"].submit();
}

export default logOutAndRedirect;
